module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/dusting-32943eaffef1587000b8e993c345d0c2.svg";